// ===== Trang THÔNG TIN THÍ SINH (chỉ XEM) =====
// Port từ 2026-vo-lam-tinh-tu/assets/thongtin/thongtin.js: init Swiper ảnh dự thi + nút zoom / click ảnh /
// click thumbnail đều mở Fancybox dạng GALLERY (đủ ảnh, next/prev được).
// $ / Swiper / Fancybox là global từ CDN libraryMainsite (varMS.bundles: jquery+swiper+fancybox = true) -> guard phòng thủ.
// Khác bản H5: mũi tên dùng class riêng .gal-prev/.gal-next (tránh CSS mặc định .swiper-button-* của lib đè sprite),
// và trang này KHÔNG có logic tặng/bình chọn nào.
window.addEventListener("load", function () {
	// ----- Slider ảnh dự thi -----
	if (typeof Swiper !== "undefined" && document.getElementById("profileSwiper")) {
		new Swiper("#profileSwiper", {
			slidesPerView: 1,
			loop: true,
			navigation: {
				nextEl: "#thongtin .gal-next",
				prevEl: "#thongtin .gal-prev",
			},
		});
	}

	// libraryMainsite CDN expose jQuery là window.$ (KHÔNG có window.jQuery).
	var $ = window.$ || window.jQuery;
	if (!$) return;

	function srcOf(a) {
		if (!a) return "";
		var href = a.getAttribute("href");
		if (href && href !== "#") return href;
		var img = a.querySelector("img");
		return img ? img.getAttribute("src") || "" : "";
	}

	// Gom URL ĐỦ các ảnh dự thi theo thứ tự từ swiper (bỏ slide clone do loop:true tạo để không lặp).
	function collectPhotos() {
		var out = [];
		var list = document.querySelectorAll(
			"#thongtin .swiper-wrapper > .swiper-slide:not(.swiper-slide-duplicate) .ph"
		);
		if (list.length === 0) {
			list = document.querySelectorAll("#thongtin .swiper-wrapper > .swiper-slide .ph");
		}
		list.forEach(function (a) {
			var s = srcOf(a);
			if (s && out.indexOf(s) === -1) out.push(s);
		});
		return out;
	}

	// Mở Fancybox gallery (list ảnh, next/prev) bắt đầu ở ảnh có src = startSrc.
	function openGallery(startSrc) {
		if (typeof window.Fancybox === "undefined") return; // lib nạp Fancybox v4; chưa nạp -> no-op
		var urls = collectPhotos();
		if (!urls.length) return;
		var idx = startSrc ? urls.indexOf(startSrc) : 0;
		if (idx < 0) idx = 0;
		window.Fancybox.show(
			urls.map(function (u) {
				return { src: u, type: "image" };
			}),
			{ startIndex: idx }
		);
	}

	// ----- Nút zoom: mở gallery đủ ảnh, bắt đầu ở ảnh của slide đang active -----
	$(document).on("click", "#thongtin .btn-zoom", function (e) {
		e.preventDefault();
		var a =
			document.querySelector("#thongtin .swiper-slide-active .ph") ||
			document.querySelector("#thongtin .swiper-wrapper .ph");
		openGallery(srcOf(a));
	});

	// ----- Click ảnh lớn hoặc thumbnail: mở cùng gallery, bắt đầu ở ảnh vừa click -----
	$(document).on(
		"click",
		"#thongtin .swiper-wrapper .ph, #thongtin .thisinh-thumbs .ph",
		function (e) {
			e.preventDefault();
			openGallery(srcOf(this));
		}
	);
});
